<!--Footer de la página-->
<template>
  <v-container fluid class="white--text text-center pa-0" :class="(currentEvent.hasOwnProperty('darkMode') && currentEvent.darkMode)?'':'primary'" :dark="(currentEvent.hasOwnProperty('darkMode') && currentEvent.darkMode)?true:false">
      <v-row justify="center">

        <!-- SECCIÓN SUPERIOR DEL FOOTER -->
        <v-col cols="12">
          <v-row justify="center" align="center">

            <v-col cols="2" md="4">
              <v-divider color="white"></v-divider>
            </v-col>

            <!-- LOGO WECHAMBER -->
            <v-col cols="6" md="2">
              <v-img src="@/assets/logo-WC.png" height="auto" width="100%"></v-img>
            </v-col>
            <!-- LOGO WECHAMBER -->

            <v-col cols="2" md="4">
              <v-divider color="white"></v-divider>
            </v-col>
          </v-row>
        </v-col>
        <!-- SECCIÓN SUPERIOR DEL FOOTER -->

        <!-- SECCIÓN DE REDES SOCIALES -->
        <v-col cols="5" md="4" class="text-left">
          <p class="headline font-weight-bold">Síguenos en redes sociales.</p>
          <p v-for="item in socialMedia" :key="item.id">
            <a :href="`${item.link}`" target="_blank">
              <v-icon color="white" class="mr-2">{{ item.icon }}</v-icon>
              {{ item.name }}
            </a>
          </p>
        </v-col>
        <!-- SECCIÓN DE REDES SOCIALES -->

        <!-- SECCIÓN DE TEMAS DE INTERÉS -->
        <v-col cols="5" md="4" class="text-right">
          <p class="headline font-weight-bold">Temas de interés.</p>
          <p v-for="item in topics" :key="item.id">
           <router-link :to="item.link" class="white--text" style="text-decoration:none">{{ item.name }}</router-link>
          </p>
        </v-col>
        <!-- SECCIÓN DE TEMAS DE INTERÉS -->

        <!-- COPYRIGHT DEL SITIO -->
        <v-col cols="11" sm="12" class="" :class="(!currentEvent.darkMode)?'wDarkerBlue':'dark-mode-2'">
          <p class="font-weight-medium"> &copy; Copyright 2021, Plataforma Digital WeChamber. All Rights Reserved.</p>
        </v-col>
        <!-- COPYRIGHT DEL SITIO -->
  
      </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  data(){
    return{
      socialMedia:[ 
        { id:"1", name:'Facebook', icon:'fab fa-facebook-square', link:"https://www.facebook.com/WeChamber-1878626478915785/"},
        { id:"2", name:'Instagram', icon:'fab fa-instagram',  link:"https://instagram.com/wechamber?igshid=2otgl2ubntj3"},
        { id:"3", name:'LinkedIn', icon:'fab fa-linkedin', link:"https://www.linkedin.com/company/wechamber/"}
      ],
      topics:[ 
        { id:"1", name:'Aviso de privacidad', link:'/aviso-de-privacidad' },
        { id:"2", name:'Términos y condiciones', link:'/terminos-y-condiciones' },
        { id:"3", name:'Precios y comisiones', link:'/precios-y-comisiones'},
        { id:"4", name:'Contacto', link:'/contacto' },
      ]
    }
  },
  computed:{
    ...mapState("event", ["currentEvent"]),
  },
}
</script>
<style scoped>
a{
  color: rgb(255, 255, 255)!important;
  text-decoration: none;
}
</style>